import React from 'react';
import PropTypes from "prop-types";
import Icon from '../Icon';
import { formatClassName } from '../../Util';

const ComplexTableColumn = ({
  columnConfig,
  header,
  headerIcon,
  headerSize
}) => {

  const headerClassName = formatClassName([
    'complex-column-header',
    `complex-column-header-${headerSize}`
  ])

  const renderColumnConfig = () => {
    return (
      <>
        {columnConfig.map((row) => {
          if(Array.isArray(row)) {
            return (
              <div className="complex-column-row">
                {row.map((subRow) => {
                  return (
                    <>
                      {subRow.label && <div className="complex-column-value">
                        {subRow.icon && <Icon iconType={subRow.icon} />}
                        {subRow.label}
                      </div>}
                    </>
                  )
                })}
              </div>
            )
          } else {
            return (
              <>
                {row.label && <div className="complex-column-row">
                  <div className="complex-column-value">
                    {row.icon && <Icon iconType={row.icon}/>}
                    {row.label}
                  </div>
                </div>}
              </>
            )
          }
        })}
      </>
    )
  }

  return (
    <div className="complex-table-column">
      {header && <div className={headerClassName}>{headerIcon && <Icon iconType={headerIcon} />}{header}</div>}
      {columnConfig && renderColumnConfig()}
    </div>
  )
}

ComplexTableColumn.propTypes = {
  columnConfig: PropTypes.arrayOf(PropTypes.shape({
    columnRow: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string
      })),
      PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string
      })
    ])
  })),
  header: PropTypes.string,
  headerIcon: PropTypes.string,
  headerSize: PropTypes.oneOf([14, 16, 18])
}

ComplexTableColumn.defaultProps = {
  headerSize: 16
}

export default ComplexTableColumn;
